import React, { useCallback } from "react";
import PropTypes from "prop-types";

const DownloadLink = ({ url, className, children }) => {
  const forceDownload = useCallback(
    (e) => {
      e.preventDefault();
      window.location = url;
    },
    [url]
  );

  return (
    <a
      href="#"
      onClick={forceDownload}
      className={className}
    >
      {children}
    </a>
  );
};

DownloadLink.propTypes = {
  url: PropTypes.string.isRequired,
  children: PropTypes.node,
  className: PropTypes.string,
};

export default DownloadLink;
